<template>
  <div>
    <!-- Filtros -->
    <b-card no-body>
      <b-card-body>
        <b-row class="mb-1 mt-1 align-items-center">
          <b-col md="2">
            <b-form-input
              v-model="filters.from"
              type="date"
              placeholder="Fecha Inicio"
              @change="getData"
            />
          </b-col>
          <b-col md="2">
            <b-form-input
              v-model="filters.to"
              type="date"
              placeholder="Fecha Final"
              @change="getData"
            />
          </b-col>
          <b-col md="3">
            <v-select
              v-model="filters.companyId"
              :options="companies"
              label="name"
              :reduce="(c) => c.id"
              placeholder="Empresa"
              @input="getData"
            />
          </b-col>
          <b-col md="2">
            <b-button variant="secondary" class="mr-1" @click.prevent="clean">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>
          <b-col md="3" class="text-right">
            <b-button variant="success" @click="openUploader"
              >Importar Excel</b-button
            >
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- Tabla -->
    <b-card no-body>
      <b-table
        :items="records"
        :fields="fields"
        :per-page="showEntrie"
        :current-page="currentPage"
        :sort-by.sync="sort"
        :sort-desc.sync="isDesc"
        show-empty
        empty-text="No hay movimientos cargados"
        responsive
      >
        <template #cell(company)="data">{{
          getCompanyName(data.item.company.name)
        }}</template>
        <template #cell(uploadedAt)="data">
          <span>{{
            moment(data.item.uploadedAt).format("YYYY-MM-DD - HH:mm")
          }}</span>
        </template>
        <template #cell(filenameDisplay)="data">
          <span>{{ data.item.filename }}</span>
        </template>
        <template #cell(actions)="data">
          <b-button
            variant="danger"
            size="sm"
            @click="confirmDelete(data.item.id)"
            v-b-tooltip.hover
            title="Eliminar"
          >
            <feather-icon icon="TrashIcon" size="16" />
          </b-button>
        </template>
        <template #cell(filename)="data">
          <a
            :href="`${UPLOADURL}/uploads/${data.item.filename}`"
            target="_blank"
            download
            v-b-tooltip.hover
            title="Descargar archivo"
            class="text-decoration-none"
          >
            <feather-icon icon="FileTextIcon" size="18" />
          </a>
        </template>
      </b-table>

      <!-- Paginación -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col sm="3">
            <b-form-group
              label-cols="4"
              label-cols-md="4"
              label-size="md"
              label="Entradas"
              label-for="input-md"
            >
              <b-form-select
                v-model="showEntrie"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="entries"
                @change="changeSizePage"
              />
            </b-form-group>
          </b-col>
          <b-col sm="3" class="mt-75" style="font-size: 12px">
            <span> {{ totalElements }} Registros en total</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalElements"
              :per-page="showEntrie"
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- Modal: Subida de Excel -->
    <b-modal id="upload-modal" title="Importar archivo Excel" hide-footer>
      <b-form @submit.prevent="uploadFile">
        <b-form-file v-model="file" accept=".xlsx" @input="validateFile" multiple/>
        <div class="mt-3 d-flex justify-content-end">
          <b-button variant="secondary" @click="$bvModal.hide('upload-modal')"
            >Cancelar</b-button
          >
          <b-button
            variant="primary"
            type="submit"
            class="ml-2"
            :disabled="!validFile"
            >Subir</b-button
          >
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import FinancialMovementService from "@/services/FinancialMovement";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import { FileTextIcon } from "vue-feather-icons";
import Ripple from "vue-ripple-directive";
import moment from "moment";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    vSelect,
    FileTextIcon,
  },
  data() {
    return {
      file: [],
      validFile: false,
      showEntrie: 10,
      currentPage: 1,
      sort: "date",
      UPLOADURL: process.env.UPLOADURL,
      isDesc: true,
      records: [],
      entries: [5, 10, 20, 50, 100],
      companies: [],
      totalElements: 0,
      filters: {
        from: "",
        to: "",
        companyId: null,
      },
      fields: [
        { key: "company", label: "Empresa", sortable: true },
        { key: "uploadedAt", label: "Fecha de ingreso", sortable: true },
        { key: "filenameDisplay", label: "Nombre de archivo", sortable: true },
        { key: "filename", label: "Archivo" },
        { key: "actions", label: "Acciones" },
      ],
    };
  },
  mounted() {
    this.loadCompaniesFromUploads();
    this.getData();
  },
  methods: {
    changeSizePage() {
      this.getData();
    },
    openUploader() {
      this.file = null;
      this.validFile = false;
      this.$bvModal.show("upload-modal");
    },
    validateFile(files) {
      const validFiles = [];
      for (const file of files) {
        const isValid = file.name.endsWith(".xlsx");
        const alreadyExists = this.records.some((r) => r.filename === file.name);
        if (isValid && !alreadyExists) {
          validFiles.push(file);
        }
      }

      if (validFiles.length === 0) {
        this.$swal({
          icon: "error",
          title: "Archivo inválido o duplicado",
          text: "Asegúrate de subir archivos .xlsx que no se hayan subido ya.",
        });
        this.file = [];
        this.validFile = false;
        return;
      }

      this.$swal({
        icon: "question",
        title: "¿Estás seguro?",
        text: `Se importarán ${validFiles.length} archivos.`,
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
      }).then((result) => {
        if (result.value) {
          this.validFile = true;
          this.file = validFiles;
        } else {
          this.file = [];
        }
      });
    },

    async uploadFile() {
      const formData = new FormData();
      for (const f of this.file) {
        formData.append("files", f);
      }
      try {
        await FinancialMovementService.uploadExcel(formData, this.$store);
        this.$bvModal.hide("upload-modal");
        this.$swal({ icon: "success", title: "Archivo subido exitosamente" });
        await this.loadCompaniesFromUploads();
        this.getData();
      } catch (err) {
        console.error(err);
        this.$swal({ icon: "error", title: "Error al subir el archivo" });
      }
    },
    async loadCompaniesFromUploads() {
      try {
        const res = await FinancialMovementService.getUploads(this.$store);
        const seen = new Set();
        const uploads = Array.isArray(res) ? res : res.data || [];

        this.companies = uploads
          .map((u) => u.company)
          .filter((c) => c && !seen.has(c.id) && seen.add(c.id))
          .map((c) => ({
            ...c,
            name: this.getCompanyName(c.name),
          }));
      } catch (err) {
        console.error("Error al cargar empresas desde uploads:", err);
        this.companies = [];
      }
    },
    getCompanyName(code) {
      const names = {
        "191-2266254-0-53": "GQR Soles",
        "191-2289861-1-17": "GQR Dólares",
        "191-6661536-0-40": "GQR Recaudadora Soles",
        "191-6661491-1-96": "GQR Recaudadora Dólares",
        "191-2545696-0-99": "KONIN Soles",
        "191-2548669-1-39": "KONIN Dólares",
        "191-2358595-0-90": "C&F Soles",
        "191-2443055-1-32": "C&F Dólares",
        "193-9827975-0-72": "NIKKEI Soles",
        "193-9845813-1-64": "NIKKEI Dólares",
      };
      return names[code] || code;
    },
    async getData() {
      try {
        const res = await FinancialMovementService.getUploads(this.$store);
        let data = Array.isArray(res) ? res : res.data || [];

        if (this.filters.companyId) {
          data = data.filter(
            (item) => item.company?.id === this.filters.companyId
          );
        }

        if (this.filters.from) {
          const fromDate = moment(this.filters.from, "YYYY-MM-DD").startOf("day").toDate();
          console.log("From Date:", fromDate);
          fromDate.setHours(0, 0, 0, 0);
          data = data.filter((item) => new Date(item.uploadedAt) >= fromDate);
        }

        if (this.filters.to) {
          const toDate = moment(this.filters.to, "YYYY-MM-DD").endOf("day").toDate();
          console.log("To Date:", toDate);
          toDate.setHours(23, 59, 59, 999);
          data = data.filter((item) => new Date(item.uploadedAt) <= toDate);
        }

        this.records = data;
        this.totalElements = this.records.length;
      } catch (err) {
        console.error("Error al obtener datos:", err);
        this.records = [];
        this.totalElements = 0;
      }
    },
    confirmDelete(id) {
      this.$swal({
        title: "¿Estás seguro?",
        text: "Esto eliminará el archivo y sus transacciones asociadas.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
          try {
            await FinancialMovementService.deleteUpload(id, this.$store);
            this.$swal({
              icon: "success",
              title: "Eliminado",
              text: "El archivo fue eliminado correctamente.",
            });
            this.getData();
          } catch (err) {
            console.error("Error al eliminar:", err);
            this.$swal({
              icon: "error",
              title: "Error",
              text: "No se pudo eliminar el archivo.",
            });
          }
        }
      });
    },

    clean() {
      this.filters.from = "";
      this.filters.to = "";
      this.filters.companyId = null;
      this.currentPage = 1;
      this.getData();
    },
  },
};
</script>
